var $72154f991a3b367d$exports = {};
$72154f991a3b367d$exports = {
    "valid": `V\xe1lido`
};


export {$72154f991a3b367d$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
